import { waitFor } from '@codeleap/utils'
import { QueryKeys } from './queryKeys'
import { appStatusStore } from '@/stores'
import { useCreate } from './useCreate'

export function useSignup() {
  const { createProfile } = useCreate()

  const signup = async () => {
    try {
      logger.debug('Creating profile', 'Sign Up')

      const profile = await createProfile.mutateAsync()
      
      await waitFor(1000)
      
      await QueryKeys.me.refresh()

      if (!profile) {
        throw new Error('Profile creation failed')
      }

      appStatusStore.setAuthFinished(true)

      return {
        user: profile,
      }
    } catch (err) {
      appStatusStore.set('idle')
      return null
    }
  }

  return { signup }
}
